/* Riwaaj Ka Rang — founder reels: click to play, click again to pause. */
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = () => {
    document.querySelectorAll('[data-rk-reel]').forEach((frame) => {
      /* several sections include this script; bind each frame exactly once */
      if (frame.dataset.rkBound) return;
      frame.dataset.rkBound = 'true';

      const video = frame.querySelector('video');
      const play = frame.querySelector('.rk-reel__play');
      const sound = frame.querySelector('.rk-reel__sound');
      if (!video || !play) return;

      const setPlaying = (playing) => {
        frame.classList.toggle('is-playing', playing);
        play.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
        if (sound) sound.hidden = !playing;
      };

      const autoplayHere = () =>
        frame.hasAttribute('data-rk-autoplay') && phone.matches;

      const toggle = () => {
        if (video.paused) {
          /* pause any other reel first — except where every reel autoplays */
          if (!autoplayHere()) {
            document.querySelectorAll('[data-rk-reel] video').forEach((other) => {
              if (other !== video && !other.paused) {
                other.pause();
                other.closest('[data-rk-reel]')?.classList.remove('is-playing');
              }
            });
          }
          video.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
        } else {
          video.pause();
          setPlaying(false);
        }
      };

      play.addEventListener('click', (e) => {
        e.preventDefault();
        toggle();
      });

      if (sound) {
        sound.addEventListener('click', (e) => {
          e.preventDefault();
          video.muted = !video.muted;
          sound.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
          sound.classList.toggle('is-muted', video.muted);
        });
      }

      video.addEventListener('ended', () => setPlaying(false));
      video.addEventListener('pause', () => setPlaying(false));

      /* Reels that carry data-rk-autoplay start by themselves on a phone once
         they are on screen (muted, as phones require) and pause when they
         leave. Every other reel just pauses when scrolled away. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (autoplayHere() && !reducedMotion.matches) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                  video.muted = true;
                  video.preload = 'auto';
                  video.play().then(() => setPlaying(true)).catch(() => {});
                } else if (!entry.isIntersecting && !video.paused) {
                  video.pause();
                  setPlaying(false);
                }
              } else if (!entry.isIntersecting && !video.paused) {
                video.pause();
                setPlaying(false);
              }
            });
          },
          { threshold: [0, 0.25, 0.5, 0.75] }
        ).observe(frame);
      }

      /* on a phone, tapping the picture itself pauses / resumes an autoplaying reel */
      video.addEventListener('click', () => {
        if (autoplayHere()) toggle();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
